var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBittrex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "56px",
    viewBox: "0 0 26 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bittrex-logo-mark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bittrex-logo-mark",
    fill: "#0082D7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.26374131,15.0002911 L5.26374131,19.0379961 L7.7988983,19.0379961 L7.7988983,17.5362934 L23.0091249,17.5362934 L23.0091249,32.7558859 L7.7988983,32.7558859 L7.7988983,24.5781196 L5.26374131,24.5781196 L5.26374131,35.2926039 L25.5442819,35.2926039 L25.5442819,15.0002911 L5.26374131,15.0002911 Z M0,20.7072625 L0,41.0002911 L20.2798252,41.0002911 L20.2798252,36.7986729 L17.7453836,36.7986729 L17.7453836,38.4635731 L2.53444165,38.4635731 L2.53444165,23.2439806 L17.7453836,23.2439806 L17.7453836,31.2585494 L20.2798252,31.2585494 L20.2798252,20.7072625 L0,20.7072625 Z",
    id: "Logo-Mark"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBittrex);
export default __webpack_public_path__ + "static/media/bittrex.932434e95e70dc735a9bf44b9e69e130.svg";
export { ForwardRef as ReactComponent };